module.exports = __webpack_public_path__ + "static/media/Bank-test.130e7fd9.png";